import { useAuthStore } from '@/stores/auth'
import { storeToRefs } from 'pinia'
import { createWebHistory } from 'vue-router'
import { createRouter } from '@datadog/browser-rum-vue/vue-router-v4'
import { usePermissions } from '../stores/permissions'
import { useUserType } from '../composables/useUserType'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'main-layout',
      redirect: '/inicio',
      // redirect() {
      //   const permissionStore = usePermissions()
      //   const { userPermissions } = storeToRefs(permissionStore)

      //   if (userPermissions.value.canSeeAllRequests) {
      //     return { name: 'requests' }
      //   } else {
      //     return { name: 'my-requests' }
      //   }
      // },
      component: () => import('@/layouts/DefaultLayout.vue'),
      meta: { title: 'Inicio' },
      children: [
        {
          path: '/inicio',
          name: 'home',
          component: () => import('@/views/HomeView.vue'),
          meta: { title: 'Inicio' },
        },
        {
          path: '/pedidos',
          name: 'requests',
          component: () => import('@/views/RequestsView.vue'),
          meta: { title: 'Pedidos', isAdmin: true },
        },
        {
          path: '/mis-pedidos',
          name: 'my-requests',
          component: () => import('@/views/MyRequestsView.vue'),
          meta: { title: 'Mis pedidos' },
        },
        {
          path: '/crear-asistencia',
          name: 'create-assist',
          component: () => import('@/views/CreateAssist.vue'),
          meta: { title: 'Nueva asistencia' },
        },
        {
          path: '/crear-siniestro',
          name: 'create-order',
          component: () => import('@/views/CreateOrder.vue'),
          meta: { title: 'Nuevo siniestro' },
        },
        {
          path: '/crear-cliente',
          name: 'create-client',
          component: () => import('@/views/CreateClient.vue'),
          meta: { title: 'Nuevo cliente' },
        },
        {
          path: '/pedido/:id',
          name: 'order-detail',
          component: () => import('@/views/OrderDetailView.vue'),
          meta: { title: 'Detalle del pedido' },
          props: true,
        },
        {
          path: '/estadisticas',
          name: 'statistics',
          component: () => {
            const authStore = useAuthStore()
            const { organization } = storeToRefs(authStore)
            const permissionStore = usePermissions()
            const { userPermissions } = storeToRefs(permissionStore)

            const hasLookerPermissions = Object.keys(userPermissions.value).some(
              (key) =>
                key.startsWith('canSeeStatistics') &&
                key !== 'canSeeStatistics' &&
                userPermissions.value[key as keyof typeof userPermissions.value]
            )
            return organization.value?.lookerLink?.startsWith('http') ||
              organization.value?.lookerLink === '' ||
              (!hasLookerPermissions && userPermissions.value.canSeeStatistics)
              ? import('@/views/StatisticsView.vue')
              : import('@/views/LookerView.vue')
          },
          meta: { title: 'Estadísticas' },
        },
        {
          path: '/looker',
          name: 'looker',
          component: () => import('@/views/LookerView.vue'),
          meta: { title: 'Looker' },
        },
        {
          path: '/nueva-venta',
          name: 'new-sales',
          component: () => import('@/views/CreateSaleView.vue'),
          meta: { title: 'Nueva venta' },
        },
        {
          path: '/mis-clientes',
          name: 'my-sales',
          component: () => import('@/views/MyClientsView.vue'),
          meta: { title: 'Mis Clientes' },
        },
        {
          path: '/servicios',
          name: 'services',
          component: () => import('@/views/ServiceView.vue'),
          meta: { title: 'Servicios' },
        },
        {
          path: '/detalle-cliente/:id',
          name: 'client-detail',
          component: () => import('@/views/ClientDetailView.vue'),
          meta: { title: 'Detalle del cliente' },
          props: true,
        },
        {
          path: '/producto-registrado',
          name: 'registered-product',
          component: () => import('@/views/RegisteredProductView.vue'),
          meta: { title: 'Productos Registrados' },
        },
        // {
        //   path: '/facturacion',
        //   component: () => import('@/layouts/BillingLayout.vue'),
        //   children: [
        //     {
        //       path: '',
        //       name: 'billing',
        //       component: () => import('@/views/billing/BillingView.vue'),
        //     },
        //     {
        //       path: '/facturacion/:period',
        //       name: 'invoice-detail',
        //       component: () => import('@/views/billing/InvoiceDetailView.vue'),
        //       props: true,
        //     },
        //     {
        //       path: '/facturacion/formulario',
        //       name: 'invoice-form',
        //       component: () => import('@/views/billing/InvoiceFormView.vue'),
        //     },
        //     {
        //       path: '/facturacion/formulario-exito',
        //       name: 'success-invoice',
        //       component: () => import('@/views/billing/InvoiceSuccessView.vue'),
        //     },
        //     {
        //       path: '/facturacion/formulario-error',
        //       name: 'error-invoice',
        //       component: () => import('@/views/billing/InvoiceErrorView.vue'),
        //     },
        //     {
        //       path: '/facturacion/factura-invalida',
        //       name: 'invalid-invoice',
        //       component: () => import('@/views/billing/InvoiceInvalidView.vue'),
        //     },
        //   ],
        //   meta: { title: 'Facturación' },
        // },
        {
          path: '/admin-equipo',
          name: 'admin-team',
          component: () => import('@/views/team/AdminTeamView.vue'),
          meta: { title: 'Admin. Equipo' },
        },
        {
          path: '/agregar-usuario',
          name: 'create-user',
          component: () => import('@/views/team/CreateMemberView.vue'),
          meta: { title: 'Agregar usuario' },
        },
        {
          path: '/editar-usuario/:id',
          name: 'edit-user',
          component: () => import('@/views/team/EditMemberView.vue'),
          meta: { title: 'Editar usuario' },
          props: true,
        },
        {
          path: '/configuracion',
          name: 'configuration',
          component: () => import('@/views/ConfigurationView.vue'),
          meta: { title: 'Configuración' },
        },
        {
          path: '/:pathMatch(.*)*',
          name: 'not-found',
          component: () => import('@/views/NotFoundView.vue'),
          meta: { title: 'Página no encontrada' },
        },
      ],
    },
    {
      path: '/guia-de-ayuda',
      name: 'help-guide-layout',
      component: () => import('@/layouts/HelpGuideLayout.vue'),
      meta: { title: 'Guía de ayuda' },
      children: [
        {
          path: '/guia-de-ayuda',
          name: 'help-guide',
          component: () => import('@/views/help/HelpGuide.vue'),
          meta: { title: 'Guía de ayuda' },
        },
        {
          path: '/guia-pedidos',
          name: 'help-requests',
          component: () => import('@/views/help/HelpAllRequestsView.vue'),
          meta: { title: 'Guía Pedidos', isAdmin: true },
        },
        {
          path: '/guia-mis-pedidos',
          name: 'help-my-requests',
          component: () => import('@/views/help/HelpMyRequestsView.vue'),
          meta: { title: 'Guía mis Pedidos', isAdmin: true },
        },
        {
          path: '/guia-pedido',
          name: 'help-request',
          component: () => import('@/views/help/HelpRequestView.vue'),
          meta: { title: 'Guía Pedido', isAdmin: true },
        },
        {
          path: '/guia-chat',
          name: 'help-chat',
          component: () => import('@/views/help/HelpChat.vue'),
          meta: { title: 'Guía Chat', isAdmin: true },
        },
        {
          path: '/guia-crear-asistencia',
          name: 'help-create-assistance',
          component: () => import('@/views/help/HelpCreateAssistanceView.vue'),
          meta: { title: 'Guía Crear Asistencia', isAdmin: true },
        },
        {
          path: '/guia-crear-siniestro',
          name: 'help-create-order',
          component: () => import('@/views/help/HelpCreateOrderView.vue'),
          meta: { title: 'Guía Crear Siniestro', isAdmin: true },
        },
        {
          path: '/guia-crear-cliente',
          name: 'help-create-client',
          component: () => import('@/views/help/HelpCreateClientView.vue'),
          meta: { title: 'Guía Cliente', isAdmin: true },
        },
        {
          path: '/guia-estadisticas',
          name: 'help-statistics',
          component: () => import('@/views/help/HelpStatisticView.vue'),
          meta: { title: 'Guía Estadísticas', isAdmin: true },
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginView.vue'),
      meta: { title: 'Vaitty - Login' },
    },
    {
      path: '/autologin/:org',
      name: 'autologin',
      component: () => import('@/views/AutologinView.vue'),
      meta: { title: 'Vaitty - Autologin' },
    },
    {
      path: '/autologin-error',
      name: 'autologin-error',
      component: () => import('@/views/AutologinErrorView.vue'),
      meta: { title: 'Rapihogar - Autologin Error' },
    },
  ],
  scrollBehavior() {
    return { top: 0, behavior: 'smooth' }
  },
})

const publicRoute = ['login', 'autologin-error']

router.beforeEach((to) => {
  document.title = `${to.meta.title}`
  const authStore = useAuthStore()
  const { isAuthenticated } = storeToRefs(authStore)
  const permissionStore = usePermissions()
  const { userPermissions } = storeToRefs(permissionStore)
  const { canAccessTeamManagement } = useUserType()
  const isPublicRoute = publicRoute.includes(to.name as string) || to.path.startsWith('/autologin/')

  if (!isAuthenticated.value && !isPublicRoute) {
    return { name: 'login' }
  }

  if (isAuthenticated.value && authStore.user?.all_signed !== true && to.name !== 'login') {
    authStore.needsPolicyAcceptance = true
    return { name: 'login' }
  }

  if (!userPermissions.value.canSeeAllRequests && to.name === 'requests' && to.meta.isAdmin) {
    return { name: 'home' }
  }

  const allowedRoutes = [
    { name: 'my-requests', condition: userPermissions.value.canSeeMyRequests },
    {
      name: 'create-order',
      condition: userPermissions.value.canCreateRequests || userPermissions.value.canCreateSiniestrosRequests,
    },
    { name: 'create-client', condition: userPermissions.value.canAddClient },
    { name: 'create-assist', condition: userPermissions.value.canCreateAssistanceRequests },
    { name: 'statistics', condition: userPermissions.value.canSeeStatistics },
    {
      name: 'new-sales',
      condition:
        userPermissions.value.canCreateSubscription ||
        userPermissions.value.canAddSubscriptionCobroexpress ||
        userPermissions.value.canAddSubscriptionPagoTic,
    },
    { name: 'my-sales', condition: userPermissions.value.canSeeSubscription },
    { name: 'services', condition: userPermissions.value.canSeeSubscription },
    { name: 'billing', condition: userPermissions.value.canSeeSubscription },
    { name: 'admin-team', condition: canAccessTeamManagement.value },
    { name: 'create-user', condition: canAccessTeamManagement.value },
    { name: 'edit-user', condition: canAccessTeamManagement.value },
    { name: 'admin-team', condition: userPermissions.value.canManageTeam },
    { name: 'create-user', condition: userPermissions.value.canManageTeam },
    { name: 'edit-user', condition: userPermissions.value.canManageTeam },
  ]

  for (const route of allowedRoutes) {
    if (to.name === route.name && !route.condition) {
      return { name: 'home' }
    }
  }

  const allowedHelpRoutes = [
    { name: 'help-requests', condition: userPermissions.value.canSeeAllRequests },
    { name: 'help-my-requests', condition: userPermissions.value.canSeeMyRequests },
    { name: 'help-request', condition: userPermissions.value.canSeeMyRequests },
    { name: 'help-chat', condition: userPermissions.value.canSeeChatRequests },
    { name: 'help-create-order', condition: userPermissions.value.canCreateRequests },
    { name: 'help-create-assistance', condition: userPermissions.value.canCreateRequests },
    { name: 'help-create-client', condition: userPermissions.value.canAddClient },
    { name: 'help-statistics', condition: userPermissions.value.canSeeStatistics },
  ]

  for (const route of allowedHelpRoutes) {
    if (to.name === route.name && !route.condition) {
      return { name: 'help-guide' }
    }
  }
})

export default router
